import { z } from "zod";

import { DatasetIdList } from "../../../schemas/analytics/base";

export const DownloadExperienceRequestQueryParamSchema = z.object({
  datasetId: z.enum(DatasetIdList).optional().default("ordersExport"),
  sendTo: z.string().optional(),
  startTs: z.string().optional(),
  endTs: z.string().optional(),
  shippingExpensePerOrder: z.string().optional(),
  transactionFeePct: z.string().optional(),
  maxZScore: z.string().optional(),
});

export type DownloadExperienceRequestQueryParamType = z.infer<
  typeof DownloadExperienceRequestQueryParamSchema
>;

export const DownloadExperienceRequestPathParamSchema = z.object({
  experienceId: z.string(),
});

export type DownloadExperienceRequestPathParamType = z.infer<
  typeof DownloadExperienceRequestPathParamSchema
>;

export const DownloadExperienceResponseBodySchema = z.object({
  message: z.string(),
  url: z.string().optional(),
});

export type DownloadExperienceResponseBodyType = z.infer<
  typeof DownloadExperienceResponseBodySchema
>;
